import cn from 'classnames';
import React from 'react';
import classes from './Button.module.scss';

export interface ButtonProps {
    text?: string | null;
    type?: 'submit' | 'button';
    variant?: 'plain' | 'justicon';
    icon?: 'reload' | 'trash';
    onClick?: () => void;
    className?: string;
}

const Button = ({
    text = '',
    type = 'button',
    variant = 'plain',
    icon,
    onClick = () => {},
    className,
}: ButtonProps) => {
    return (
        <button
            className={cn(classes.button, classes[variant], className)}
            type={type === 'button' ? 'button' : 'submit'}
            onClick={onClick}
        >
            {text}
            {icon && <div className={cn(classes.icon, classes[icon], text && classes.gap)} />}
        </button>
    );
};
export default Button;
